import ProfileDetails from "../../slices/users/profile/ProfileDetails";
import CustomerList from "../../slices/users/customer/CustomerList";
import CustomerDetails from "../../slices/users/customer/CustomerDetails";
import MemberList from "../../slices/users/member/MemberList";
import MemberDetails from "../../slices/users/member/MemberDetails";
import AgronomyList from "../../slices/users/agronomy/AgronomyList";
import AgronomyDetails from "../../slices/users/agronomy/AgronomyDetails";
import SupervisorList from "../../slices/users/supervisor/SupervisorList";
import SupervisorDetails from "../../slices/users/supervisor/SupervisorDetails";
import StaffList from "../../slices/users/staff/StaffList";
import StaffDetails from "../../slices/users/staff/StaffDetails";

const usersReducer = {
    profileDetails: ProfileDetails,
    customerList: CustomerList,
    customerDetails: CustomerDetails,
    memberList: MemberList,
    memberDetails: MemberDetails,
    agronomyList: AgronomyList,
    agronomyDetails: AgronomyDetails,
    supervisorList: SupervisorList,
    supervisorDetails: SupervisorDetails,
    staffList: StaffList,
    staffDetails: StaffDetails,
};

export default usersReducer;